<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle1"><a id="page_vii"><b>CONTENTS</b></a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/08_Foreword">•  <i>Foreword</i></a> <i>by John C. Spychalski</i></p>
<p class="toc"><a href="#/xhtml/09_Abbreviations">•  <i>List of Abbreviations</i></a></p>
<p class="toc"><a href="#/xhtml/10_ImportantNames">•  <i>List of Important Names</i></a></p>
<p class="toc"><a href="#/xhtml/12_Introduction">•  Introduction</a></p>
<p class="toc"><a href="#/xhtml/13_Chapter01">1  The Age of Innocence</a></p>
<p class="toc"><span href="#/xhtml/14_Chapter02" title="Link target outside of Sample">2  The Gathering Storm</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter03" title="Link target outside of Sample">3  A Time of Waiting</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter04" title="Link target outside of Sample">4  The Beginning</span></p>
<p class="toc"><span href="#/xhtml/17_Chapter05" title="Link target outside of Sample">5  The Plot Thickens</span></p>
<p class="toc"><span href="#/xhtml/18_Chapter06" title="Link target outside of Sample">6  Fear and Exhaustion</span></p>
<p class="toc"><span href="#/xhtml/19_Chapter07" title="Link target outside of Sample">7  Detailed Case Preparation</span></p>
<p class="toc"><span href="#/xhtml/20_Chapter08" title="Link target outside of Sample">8  The Times That Try Men’s Souls</span></p>
<p class="toc"><span href="#/xhtml/21_Chapter09" title="Link target outside of Sample">9  The Rail Use Case: Ours and the Government’s</span></p>
<p class="toc1"><span href="#/xhtml/22_Chapter10" title="Link target outside of Sample">10  The Government’s Case</span></p>
<p class="toc1"><a id="page_viii"></a><span href="#/xhtml/23_Chapter11" title="Link target outside of Sample">11  End Game</span></p>
<p class="toc"><span href="#/xhtml/24_Epilogue" title="Link target outside of Sample">•  Epilogue</span></p>
<p class="toc"><span href="#/xhtml/25_Notes" title="Link target outside of Sample">•  <i>Notes</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?5415d8ff